import React, { useState } from "react";
import "./InputField.css";
import "./CountrySelector.css";
import { ReactComponent as Arrow } from "../assets/arrow.svg";
import { ReactComponent as ArrowDisabled } from "../assets/arrow_disabled.svg";
import globalConfig from "../utils/config.json";

function CountrySelectorInputField({ id, placeholder, value, onChange, disabled, hint, onCountrySelected, selectedCountryConfig }) {
  const [opened, setOpened] = useState(false);
  // const ref = useRef(null);

  function showDropdown() {
    if (!disabled) {
      console.log("showDropdown");
      // ref.current.focus();
      setOpened(!opened);
    }
  }

  function getFlagImage(countryConfig) {
    if (countryConfig != null) {
      return "url(/flags/" + countryConfig.cc.toLowerCase() + ".svg)";
    }
    return null;
  }

  function onCountryClick(client) {
    onCountrySelected(client);
    setOpened(false);
  }

  return (
    <div className="inputFieldWrapper">
      <div className={"countrySelectorWrapper"}>
        <div className="countrySelector" onClick={showDropdown}>
          {/* <input className="dummyInputField" readOnly type="none" ref={ref} onBlur={() => {if (opened) setOpened(false);}}/> */}
          <div className="countrySelectorFlag" style={{ backgroundImage: getFlagImage(selectedCountryConfig) }}>
            <div className={"countrySelectorCc" + (disabled ? " disabled" : "")}>{selectedCountryConfig ? "+" + selectedCountryConfig.prefix : ""}</div>
          </div>
          {disabled ? <ArrowDisabled className={"arrow" + (opened ? " opened" : "")} /> : <Arrow className={"arrow" + (opened ? " opened" : "")} />}
        </div>
        <ul className={"dropdown-content" + (opened ? " show" : "")}>
          {globalConfig.clients
            .sort(function (a, b) {
              return a.country.localeCompare(b.country);
            })
            .map((client) => (
              <li className={"listItem"} key={client.cc} style={{ backgroundImage: getFlagImage(client) }} onClick={() => onCountryClick(client)}>
                <p className="country">{client.country} </p>
                <p className="prefix">+{client.prefix}</p>
              </li>
            ))}
        </ul>
      </div>
      <input id={id} className="inputField" disabled={disabled} type="tel" placeholder={disabled ? "" : placeholder} value={value} onChange={onChange} />

      <div className={disabled ? "disabledHint" : "hint"}>{hint}</div>
    </div>
  );
}

export default React.memo(CountrySelectorInputField);
